import { NegotiationRoundStatus, type NegotiationRoundV2Dto } from "../../../../autogen/bff-api";

/**
 * A round has been sent once it leaves DRAFT. Status is the signal rather than `publishedAt`
 * because it states the thing directly: `publishedAt` is derived from a Published transition in the
 * round's history, so it says the same for well-formed data but goes quiet if that history is ever
 * incomplete — and a COMPLETED round is one the suppliers plainly saw either way.
 */
const isSent = (round: NegotiationRoundV2Dto): boolean =>
  round.status !== NegotiationRoundStatus.Draft;

/**
 * The newest round the suppliers have actually seen. A draft round exists only in the buyer's
 * hands — its deadline is still theirs to move — so the timeline waits for it to be sent before
 * letting it speak for the competition.
 */
export const latestPublishedRound = (
  rounds: readonly NegotiationRoundV2Dto[],
): NegotiationRoundV2Dto | null =>
  rounds.reduce<NegotiationRoundV2Dto | null>(
    (latest, round) =>
      isSent(round) && (latest == null || round.roundNumber > latest.roundNumber) ? round : latest,
    null,
  );

export const publishedRounds = (
  rounds: readonly NegotiationRoundV2Dto[],
): NegotiationRoundV2Dto[] =>
  [...rounds].filter(isSent).sort((a, b) => a.roundNumber - b.roundNumber);
